"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedNetworkAnalysisOptsSerializedSchema = exports.SegmentedNetworkAnalysisResultSerializedSchema = void 0;
const zod_1 = require("zod");
const AnalysisRequirements_1 = require("../../AnalysisRequirements");
const CircuitStates_1 = require("../../CircuitStates");
const ProjectModelNetStats_1 = require("../../DesignModels/ProjectModelNetStats");
exports.SegmentedNetworkAnalysisResultSerializedSchema = zod_1.default.object({
    type: zod_1.default.literal(AnalysisRequirements_1.AnalysisType.SegmentedNetworkAnalysis),
    result: zod_1.default.object({
        viewResults: zod_1.default.record(zod_1.default.string(), zod_1.default.string().array()),
        droppedViews: zod_1.default.record(zod_1.default.string(), zod_1.default.string()),
        aggregateNetStats: ProjectModelNetStats_1.ProjectModelNetStatsSchema,
    }),
});
exports.SegmentedNetworkAnalysisOptsSerializedSchema = zod_1.default.object({
    rootModeTreeVector: CircuitStates_1.IModeTreeStateVectorSerializedSchema,
});
//# sourceMappingURL=SegmentedNetworkAnalysisResultSerialized.js.map